import { KeyValueModel } from '@/app/proxy/proxies';

export interface InquiryTypeQuickAction {
  /** Stable id from the lookup (`key`); also used as `inquiryTypeId`. */
  key: string;
  /** Display label from the lookup (`value`). */
  label: string;
  inquiryTypeId: string;
}

/**
 * Builds welcome quick actions from `GET /v4.0/lookup/inquiry-types-v2`.
 * That endpoint is the source of truth for the "Doktar AI & Support" module
 * (legacy hardcoded ids in `comms-consts.ts` belong to the older `support`
 * module and aren't guaranteed to match this v2 set).
 */
export function mapInquiryTypesToQuickActions(
  types: KeyValueModel[] | undefined
): InquiryTypeQuickAction[] {
  return (types || [])
    .filter((type): type is KeyValueModel & { key: string; value: string } => !!type.key && !!type.value)
    .map((type) => ({
      key: type.key,
      label: type.value,
      inquiryTypeId: type.key,
    }));
}
